import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=536a9d50&scoped=true&"
import script from "./PendingApproval.vue?vue&type=script&lang=js&"
export * from "./PendingApproval.vue?vue&type=script&lang=js&"
import style0 from "./PendingApproval.vue?vue&type=style&index=0&id=536a9d50&prod&lang=scss&scoped=true&"
import style1 from "./PendingApproval.vue?vue&type=style&index=1&id=536a9d50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536a9d50",
  null
  
)

export default component.exports